/* eslint-disable no-unused-vars */
import _ from 'lodash';
import moment from 'moment';

const getFormFields = ({ isNewEquipment, dropdownMenuMapList, isVesselVersion, isPSVVersion }) => {
  const isMasterData = isNewEquipment ? false : true;

  let categoryTypeAndSubTypeList = isVesselVersion
    ? dropdownMenuMapList?.EquipmentCategoryTypeSubtypePickList?.filter(
        (x) => x?.allowedForPVCreation
      )
    : isPSVVersion
    ? dropdownMenuMapList?.EquipmentCategoryTypeSubtypePickList?.filter(
        (x) => x?.allowedForPSVCreation
      )
    : dropdownMenuMapList?.EquipmentCategoryTypeSubtypePickList;

  categoryTypeAndSubTypeList = categoryTypeAndSubTypeList?.filter((x) => x?.child?.length);

  return [
    ...(!isNewEquipment
      ? [
          {
            label: 'Equipment #',
            name: 'equipmentNumber',
            type: 'Text',
            required: false,
            isReadOnly: true,
            order: 1
          }
        ]
      : []),
    {
      label: 'Name',
      isMasterData,
      name: 'name',
      required: true,
      type: 'Text',
      order: 2
    },
    {
      isMasterData,
      label: 'Status',
      name: 'status',
      type: 'Dropdown',
      required: true,
      options: dropdownMenuMapList?.EquipmentStatusPickList || [],
      order: 3
    },
    {
      isMasterData,
      label: 'Category / Type / Subtype',
      name: 'equipmentCategoryTypeSubType',
      type: 'HierarchicalDropdown',
      required: true,
      order: 4,
      options: categoryTypeAndSubTypeList
    },

    {
      isMasterData,
      label: 'Description',
      name: 'description',
      required: false,
      type: 'LongText',
      order: 5
    },

    {
      isMasterData,
      label: 'Manufacturer',
      name: 'manufacturer',
      required: false,
      type: 'Text',
      order: 6
    },

    {
      isMasterData,
      label: 'Model',
      name: 'model',
      required: false,
      type: 'Text',
      order: 7
    },

    {
      isMasterData,
      label: 'Physical Location',
      name: 'physicalLocation',
      required: false,
      type: 'Text',
      order: 8
    },

    {
      isMasterData,
      label: 'Serial #',
      name: 'serial',
      required: false,
      type: 'Text',
      order: 9
    },

    {
      grid2: true,
      fields: [
        {
          isMasterData,
          label: 'Jurisdiction',
          name: 'jurisdiction',
          type: 'Dropdown',
          required: false,
          options: dropdownMenuMapList?.ProvincesPickList || []
        },

        {
          isMasterData,
          label: 'Jurisdiction #',
          name: 'jurisdictionNumber',
          type: 'Text',
          required: false
        }
      ],
      order: 10
    },

    {
      isMasterData,
      label: 'Field Tag #',
      name: 'fieldTagNumber',
      type: 'Text',
      required: false,
      order: 11
    },

    {
      isMasterData,
      label: 'Year Built',
      name: 'manufacturedYear',
      type: 'Text',
      required: false,
      order: 12
    }
  ];
};

const getMoreInfoFormFields = ({
  equipmentFormsUserCache,
  dropdownMenuMapList,
  isPSVVersion,
  selectedFieldObjIds = [],
  isNewEquipment
}) => {
  const formFields = equipmentFormsUserCache;

  let fields = [];
  let order = 1;
  for (let field of formFields) {
    let removeSpecialCharactersForName = removeSpecialCharacters(
      field?.displayName?.toString()?.toLowerCase()
    );
    removeSpecialCharactersForName = `${removeSpecialCharactersForName}-${field?.id}`;
    let singleName = removeSpecialCharactersForName;
    removeSpecialCharactersForName = `${removeSpecialCharactersForName}`;
    let name = `moreFields.${removeSpecialCharactersForName}.${field?.id}`;

    const options =
      field?.dataType === 'Dropdown_PL' ||
      field?.dataType === 'InspectionResult' ||
      field?.dataType === 'CheckResult' ||
      field?.dataType === 'Dropdown_PL_Multiple' ||
      field?.dataType === 'Readings_PL'
        ? dropdownMenuMapList[field?.picklistName]
        : field?.options?.length
        ? field?.options
        : field?.defaultValue
        ? field?.defaultValue?.split(',')?.map((x) => {
            return {
              label: x,
              value: x
            };
          })
        : [];

    const isVisible = selectedFieldObjIds.includes(field.id) ? true : false;
    const isFieldCheckedAndDisabled =
      field?.sourceEntity === 'Equipment' &&
      [
        'Name',
        'Status',
        'Category_Type_SubType',
        'CurrentUserOrPlacement',
        'Description',
        'Manufacturer',
        'Model',
        'PhysicalLocation',
        'SerialNumber',
        'Jurisdiction',
        'JurisdictionNumber',
        'FieldTagNumber',
        'YearBuilt',
        've_inspection',
        'tank_inspection',
        'vi_inspection',
        'ut_inspection'
      ].includes(field.sourceProperty);

    const isFieldCheckedAndDisabledForStructure =
      field?.sourceEntity === 'Structure' &&
      ['StructureID', 'Status', 'Name', 'StructureType'].includes(field.sourceProperty);

    if (!isFieldCheckedAndDisabled && !isFieldCheckedAndDisabledForStructure) {
      const obj = {
        label: field?.displayName?.replace('Equipment - ', ''),

        name,
        removeSpecialCharactersForName,
        type:
          field?.picklistName === 'EquipmentCategoryTypeSubtypePickList'
            ? 'HierarchicalDropdown'
            : field?.dataType || 'Text',
        required: false,
        isReadOnly: false,
        isVisible: isVisible,
        order,
        options: options,
        formFieldId: field.id,

        Id: field.id,
        Value: field?.displayName?.replace('Equipment - ', ''),

        IsSortable: true,
        fieldName: singleName,
        checked: isVisible,
        isFieldCheckedAndDisabled,
        sourceEntity: field?.sourceEntity,
        sourceProperty: field?.sourceProperty,
        isMasterData: isNewEquipment ? false : true
      };
      fields.push(obj);

      order++;
    }
  }

  fields = sortAndMoveDisabled({ list: fields });

  return { moreInfoFormFields: fields };
};

const sortAndMoveDisabled = ({ list }) => {
  const enabled = list.filter((person) => !person.isFieldCheckedAndDisabled);
  const disabled = list.filter((person) => person.isFieldCheckedAndDisabled);

  enabled.sort((a, b) => a.name.localeCompare(b.name));
  return [...disabled, ...enabled];
};

const removeSpecialCharacters = (str) => {
  const pattern = /[^a-zA-Z0-9 ]/g;
  const result = str.replace(pattern, '');
  return result;
};

const getDataFromObjects = ({ data }) => {
  const convertedMoreFieldObj = {};
  const selectedFieldObjIds = [];
  const moreFields = data?.moreFields || {};
  const selectedFieldIds = data?.selectedMoreFields?.filter((x) => x?.checked).map((y) => y?.Id);
  for (const key in moreFields) {
    const innerKey =
      moreFields[key] && Object.keys(moreFields[key]) && Object.keys(moreFields[key])[0];

    if (innerKey) {
      const value = moreFields[key][innerKey] || null;

      const checkValueIsEmpty =
        _.isObject(value) && !value?.textBoxUnitValue && !value?.textBoxValue
          ? true
          : _.isEmpty(value)
          ? true
          : false;

      if (!checkValueIsEmpty || selectedFieldIds.includes(innerKey)) {
        selectedFieldObjIds.push(innerKey);
        const reconcileValue = moreFields[key][`${innerKey}-reconcile`] || null;

        convertedMoreFieldObj[key] = {
          [innerKey]: _.isDate(value) ? moment(new Date(value)).format('YYYY-MM-DD') : value,
          [`${innerKey}-reconcile`]: _.isDate(reconcileValue)
            ? moment(new Date(reconcileValue)).format('YYYY-MM-DD')
            : reconcileValue
        };
      }
    }
  }

  const convertedData = {
    ...data,
    moreFields: convertedMoreFieldObj,
    selectedFieldObjIds: selectedFieldObjIds.length ? selectedFieldObjIds : null
  };
  delete convertedData?.['selectedMoreFields'];
  return convertedData;
};

export { getFormFields, getMoreInfoFormFields, getDataFromObjects };
